<template>
  <tbody>
    <td :colspan="numColumns">
      <v-alert
        :value="true"
        color="warning"
        icon="mdi-message-alert-outline"
        class="ma-2 text-center"
        dark
      >
        {{ noDataMessage }}
      </v-alert>
    </td>
  </tbody>
</template>

<script>
import { mapGetters } from "vuex";
const DATA_COLUMN_LENGTH = 5;

export default {
  components: {},
  props: {},
  data: () => ({
    noDataMessage: process.env.VUE_APP_NO_CALLS_FOUND
  }),
  computed: {
    ...mapGetters("scorecardsV2", [
      "categorySkeletonData",
      "categorySkeletonDataLoadingStatus",
      "categorySkeletonDataLoadingError",
      "categorySkeletonDataLoadingErrorStatus"
    ]),
    numColumns() {
      return DATA_COLUMN_LENGTH + this.categorySkeletonData.length;
    }
  },
  methods: {},
  mounted() {},
  watch: {}
};
</script>

<style scoped></style>
